import { initializeApp, getApps, FirebaseOptions } from 'firebase/app';
import { getMessaging, isSupported } from 'firebase/messaging';

// Firebase configuration - you'll need to get these values from your Firebase project
const firebaseConfig: FirebaseOptions = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'your-api-key',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'your-project.firebaseapp.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'your-project-id',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || 'your-project.appspot.com',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || 'your-sender-id',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || 'your-app-id',
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || 'your-measurement-id'
};

// Initialize Firebase
export const initializeFirebase = () => {
  // Debug Firebase configuration
  console.log('🔥 Initializing Firebase with config:');
  const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);
  return app;
};

// Initialize Firebase Messaging
export const initializeFirebaseMessaging = async () => {
  console.log('[initializeFirebaseMessaging] Checking if Firebase messaging is supported...');

  const supported = await isSupported();
  console.log('[initializeFirebaseMessaging] Firebase messaging support result:', supported);

  if (!supported) {
    console.log(
      '[initializeFirebaseMessaging] Firebase messaging is not supported in this browser'
    );
    return null;
  }

  console.log('[initializeFirebaseMessaging] Initializing Firebase app...');
  const app = initializeFirebase();

  console.log('[initializeFirebaseMessaging] Getting messaging instance...');
  const messaging = getMessaging(app);

  console.log('[initializeFirebaseMessaging] ✅ Messaging instance created successfully');
  return messaging;
};

export default firebaseConfig;
